<template>
  <div>
    <div
      style="width: 30px; height: 30px; position: fixed; top: 0; right: 0"
      @click="escPrint"
    ></div>
    <section class="sheet padding-10mm">
      <div class="border d-flex">
        <div>
<map-view :mainObj="myData" class="my-print-map"></map-view>

<table class="table table-bordered mt-2 sign-place" dir="rtl">
  <tr>
    <td>طراح</td>
    <td>طرح و توسعه</td>
    <td>بهره‌برداری</td>
    <td>مدیر امور مرکز شهرستان ملایر</td>
    
  </tr>
  <tr>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
  </tr>
</table>
        </div>
        
        <div class="map-legend-container">
          <!-- <div class="p-1">
            <p>نام فیدر:</p>
 <p><b>{{feederName.split('_').join(" ")}}</b></p>
          </div> -->
         
         <img :src="`${publicPath}img/legend_top.png`" id="legend-top">
         <table class="table ">
           <tr><td>شهرستان</td><td>ملایر</td></tr>
           <tr><td>عنوان طرح</td><td>تبدیل سیم مسی به خودنگهدار</td></tr>
           <tr><td>نام فیدر</td><td>{{feederName.split('_').join(" ").split('LV').join("")}}</td></tr>
           <tr><td>آدرس طرح</td><td>{{feederAddress.split('_').join(" ").split('LV').join("")}}</td></tr>
            <tr><td>سایز نقشه</td><td>A4 (29x21cm)</td></tr>
            
            <tr><td>قدرت درخواستی</td><td></td></tr>
            <tr><td>قدرت موجود</td><td></td></tr>
            <tr><td>ولتاژ تامین برق</td><td></td></tr>
         </table>
        </div>
           <!-- <div id="m-feeder-name">{{ feederName }}</div>  -->
        <!-- <img alt="Vue logo" src="../assets/logo.png" /> -->
        <!-- <img alt="Vue logo" src="../assets/legend_top.PNG" /> -->
      </div>

      <!-- <img src="../assets/legend_top.PNG" width="100" height="100"> -->
    </section>
  </div>
</template>


<script>
import { ApiTls } from "../../src/app/tools/ApiTls";
// import FeederTotalCal from "../components/FeederTotalCal";
import { PrintTls } from "../app/tools/PrintTls";
import MapView from "../components/MapView";

export default {
  components: { MapView },
  name: "FeederPrintLegend",
  data() {
    return {
      feederId: 0,
      feederData: {},
      myData: {},
      feederName: "sa",
      feederAddress:"",
       publicPath: process.env.BASE_URL,
    };
  },
  mounted() {
    ApiTls.getFeederData(this.$route.params.feederId, this.setResData);
    PrintTls.makePrintable();
    document.title = this.$route.params.feederId + " - Legend - A4";
    document.getElementsByClassName( 'leaflet-control-attribution' )[0].style.display = 'none';
  },
  watch: {
    myData() {
      if (this.myData.feeder.length){
        this.feederName = this.myData.feeder[0]["feeder_name"];
        this.feederAddress = this.myData.feeder[0]["address"];
        // this.feederAddress = "Sada";
      }else {this.feederName = "";this.feederAddress="";}
    },
  },
  methods: {
    setResData(res) {
      this.myData = res.data;
    },

    escPrint() {
      PrintTls.escPrintable();
    },
  },
};
</script>



<style >
.my-print-map {
  height: 10mm;
}
body.printable .my-map,
.my-print-map {
  min-height: 140mm !important;
  height: 165mm !important;
  width: 230mm !important;

  /* height: 100%;
    width: 50%;
    position: absolute;
    right: 10mm;
    top: 10mm; */
}
.map-legend-container{
  float: right;
  
  top: 0;
  height: 190mm !important;
  width: 45mm !important;
  /* background: #333; */
  font-family: Vazir;
  direction: rtl;
  text-align: justify;
}
#legend-top{
  width: 45mm;
}
.map-legend-container table{
  margin-top: 5mm;
  width: 40mm;
  
  font-size: .5em ;
  /* border: solid #111 2px; */
  border-radius: 20px;
  /* overflow: hidden; */
  border-collapse: collapse ;
  border-radius: 10px;
    border-style: hidden; /* hide standard table (collapsed) border */
    box-shadow: 0 0 0 1px #666; /* this draws the table border  */ 
    margin-right: 2mm;
}
.map-legend-container table  td:last-child{
  font-weight: bold;
}
/* table tr:last-child td:first-child {
    border-bottom-left-radius: 10px;
}

table tr:last-child td:last-child {
    border-bottom-right-radius: 10px;
} */

.map-legend-container table td{
  padding:  3px 0 3px 0 ;
  text-align: center;
  border: solid #111 1px;
  height: 8mm;
   vertical-align: middle;
  
}

.sign-place{
  margin: 0;
}
.sign-place td{
   border: solid #111 1px;
   font-family: Vazir;
   width: 35mm;
   height: 11.3mm;
   padding: 0;
   vertical-align: middle;
   font-size: .9em;
}


</style>

<style scoped>
@page {
  size: A4 landscape;
}

#m-feeder-name {
  position: absolute;
  top: 10;
  left: 10;
  font-family: Vazir;
}



</style>